var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseS = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.404 7.404a1 1 0 0 0 0 1.414L10.586 12l-3.182 3.182a1 1 0 1 0 1.414 1.414L12 13.414l3.182 3.182a1 1 0 0 0 1.414-1.414L13.414 12l3.182-3.182a1 1 0 0 0-1.414-1.414L12 10.586 8.818 7.404a1 1 0 0 0-1.414 0",
  clipRule: "evenodd"
})));
export default SvgCloseS;